(() => {
 const config=document.getElementById('superior-shopping-config');
 const dialog=document.getElementById('superior-search-dialog');
 let searchTrigger=null;
 document.addEventListener('click',async event=>{
  const search=event.target.closest('.superior-mobile-search');
  if(search){searchTrigger=search;dialog.showModal();document.getElementById('superior-search-input').focus();return;}
  if(event.target.closest('[data-superior-search-close]'))dialog.close();
  const remove=event.target.closest('.superior-cart-remove');
  if(!remove||remove.disabled)return;
  event.preventDefault();
  const section=remove.closest('[data-superior-cart-section]');
  const buttons=section.querySelectorAll('.superior-cart-remove');
  buttons.forEach(button=>button.disabled=true);
  const error=document.getElementById('superior-cart-error');
  error.hidden=true;
  remove.setAttribute('aria-busy','true');
  try{
   const response=await fetch(config.dataset.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:remove.dataset.lineKey,quantity:0})});
   if(!response.ok)throw new Error('Cart update failed');
   await response.json();
   location.reload();
  }catch{
   error.hidden=false;
   buttons.forEach(button=>button.disabled=false);
   remove.removeAttribute('aria-busy');
  }
 });
 dialog.addEventListener('close',()=>searchTrigger?.focus({preventScroll:true}));
})();